import React from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';

import { settingTipList, tipTitle, tipContent } from './contants';
import { SettingTipItem } from './index.d';

interface ItemProps {
  item: SettingTipItem;
}

const Item = (props: ItemProps) => {
  const { item } = props;

  return (
    <div className="flex" styleName="item">
      <div className="flex" styleName="item-title-left">
        <div styleName="item-title">
          <i styleName='icon' className={`iconfont ${item.icon}`}/>
          <span>{ item.title }</span>
        </div>
        <span styleName="item-desc">{ item.desc }</span>
        {!item.isLast ? <span styleName="item-sep" /> : <span styleName="item-padding-bottom" />}
      </div>
    </div>
  )
}

const LocationSettingDetail = () => {

  const renderSettingTipItem = () => {
    const items = settingTipList.map((item: any, index: number) => {
      return (
        <Item key={ index } item={ item }/>
      )
    });

    return items;
  }

  return (
    <div styleName="container">
      <NavBar
        title="定位方式"
        transparent
      />
      <div styleName="list">
        { renderSettingTipItem() }
      </div>
      <div className="tipflex">
        <p styleName="tipTitle">{ tipTitle }</p>
        <p styleName="tipContent">{ tipContent }</p>
      </div>
    </div>
  )
}

export default LocationSettingDetail;
